import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import {
  CustomerHeaderCustomersByIdFragment,
  HeadAgreementInfoRowSectionFragment,
  HeadAgreementStatusCode,
} from "@/gql/graphql";
import { routeFactory } from "@/RouteFactory";
import { ActionMenuItem, stenaFilePdfLabel } from "@stenajs-webui/elements";
import { useNavigate } from "react-router";

interface Props {
  customer: CustomerHeaderCustomersByIdFragment | null | undefined;
  headAgreement: HeadAgreementInfoRowSectionFragment;
  setAgreementPicker: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      reportType: string;
      parentCustomerId: string;
    }>
  >;
  onRequestClose: () => void;
}

export const CreateReportMenuItems = ({
  customer,
  headAgreement,
  setAgreementPicker,
  onRequestClose,
}: Props) => {
  const navigate = useNavigate();
  const customerId = customer?.id ?? "";
  const parentCustomerId = customer?.parent?.id ?? "";

  return (
    <>
      {!customer?.parent ? (
        <>
          <ActionMenuItem
            label={"Create offer"}
            leftIcon={stenaFilePdfLabel}
            disabled={headAgreement.statusCode === HeadAgreementStatusCode.Void}
            onClick={() =>
              navigate(
                routeFactory.productAndPrice.headAgreement.createReport({
                  customerId,
                  headAgreementId: headAgreement.id,
                  reportType: "offer",
                })
              )
            }
            data-testid={testIdConstants.headerAgreementActionsMenuCreateOffer}
          />
          <ActionMenuItem
            label={"Create confirmation"}
            leftIcon={stenaFilePdfLabel}
            disabled={headAgreement.statusCode === HeadAgreementStatusCode.Void}
            onClick={() =>
              navigate(
                routeFactory.productAndPrice.headAgreement.createReport({
                  customerId,
                  headAgreementId: headAgreement.id,
                  reportType: "confirmation",
                })
              )
            }
            data-testid={
              testIdConstants.headerAgreementActionsMenuCreateConfirmation
            }
          />
        </>
      ) : (
        <>
          <ActionMenuItem
            label={"Create offer"}
            leftIcon={stenaFilePdfLabel}
            onClick={() => {
              setAgreementPicker({
                isOpen: true,
                reportType: "offer",
                parentCustomerId,
              });
              onRequestClose();
            }}
            data-testid={testIdConstants.headerAgreementActionsMenuCreateOffer}
          />
          <ActionMenuItem
            label={"Create confirmation"}
            leftIcon={stenaFilePdfLabel}
            onClick={() => {
              setAgreementPicker({
                isOpen: true,
                reportType: "confirmation",
                parentCustomerId,
              });
              onRequestClose();
            }}
            data-testid={
              testIdConstants.headerAgreementActionsMenuCreateConfirmation
            }
          />
        </>
      )}
    </>
  );
};
